const aiPromptSettingsNorwegian = {
  header: {
    title: "AI-innstillinger",
    description: "Tilpass hvordan AI-en genererer LinkedIn-innleggene dine"
  },
  sections: {
    profiles: {
      title: "LinkedIn-profiler",
      description: "Legg til lenker til LinkedIn-profiler hvis stil du ønsker å etterligne."
    },
    products: {
      title: "Produkter",
      description: "Legg til dine produkter eller tjenester som AI-en kan referere til i innleggene."
    },
    leadMagnets: {
      title: "Lead Magnets",
      description: "Legg til gratisressurser eller lead magnets du vil tilby i innleggene dine."
    },
    examples: {
      title: "Eksempler på Gode Innlegg",
      description: "Legg til eksempler på vellykkede LinkedIn-innlegg som AI-en kan lære fra."
    },
    callToAction: {
      title: "Call-to-Action-innstillinger",
      description: "Kontroller hvor ofte innleggene dine skal inneholde en call-to-action."
    },
    emoji: {
      title: "Emoji-innstillinger",
      description: "Kontroller hvor mange emojier innleggene dine skal inneholde."
    },
    language: {
      title: "Innleggsspråk",
      description: "Velg hvilket språk innleggene dine skal genereres på. Dette påvirker bare språket i innleggene, ikke brukergrensesnittets språk."
    }
  },
  buttons: {
    add: {
      profile: "Legg til profil",
      product: "Legg til produkt",
      leadMagnet: "Legg til Lead Magnet",
      example: "Legg til eksempel"
    }
  },
  modal: {
    titles: {
      addProfile: "Legg til LinkedIn-profil",
      editProfile: "Rediger LinkedIn-profil",
      addProduct: "Legg til produkt",
      editProduct: "Rediger produkt",
      addLeadMagnet: "Legg til Lead Magnet",
      editLeadMagnet: "Rediger Lead Magnet",
      addExample: "Legg til eksempel på godt innlegg",
      editExample: "Rediger eksempel på godt innlegg"
    },
    placeholders: {
      profile: "LinkedIn-profillenke (f.eks. https://www.linkedin.com/in/johndoe)",
      productName: "Produktnavn",
      productDescription: "Beskrivelse av produktet og dets funksjoner",
      leadMagnetName: "Lead magnet-navn",
      leadMagnetDescription: "Beskrivelse av ressursen og dens verdi",
      example: "Sett inn et eksempel på et godt LinkedIn-innlegg"
    },
    buttons: {
      cancel: "Avbryt",
      add: "Legg til",
      save: "Lagre endringer"
    }
  },
  ctaFrequency: {
    always: "Alltid",
    every2: "Hvert 2. innlegg",
    every3: "Hvert 3. innlegg",
    every4: "Hvert 4. innlegg",
    never: "Aldri",
    withCta: "Med CTA",
    withoutCta: "Uten CTA"
  },
  emojiFrequency: {
    none: "Ingen",
    few: "Noen få",
    medium: "Middels",
    many: "Mange",
    examples: {
      none: "Innlegg uten emojier.",
      few: "Få emojier 👍",
      medium: "Moderat med emojier 👋 for å fremheve viktige poenger ✅",
      many: "Mange emojier 🚀 for energisk tekst 🔥 som fanger blikket 👀 og skaper engasjement 💪"
    }
  },
  preferredEmojis: {
    label: "Foretrukne emojier:",
    placeholder: "Skriv inn dine foretrukne emojier (f.eks.: 🚀 ✨ 💪 🔥 👍)",
    description: "AI-en vil prioritere disse emojiene i innleggene dine, men vil fortsatt bruke andre for å sikre variasjon."
  },
  postLanguage: {
    examples: {
      da: "Dette er et eksempel på et opslag på dansk. AI'en vil generere indhold på dette sprog.",
      en: "This is an example of a post in English. The AI will generate content in this language.",
      no: "Dette er et eksempel på et innlegg på norsk. AI-en vil generere innhold på dette språket.",
      sv: "Detta är ett exempel på ett inlägg på svenska. AI:n kommer att generera innehåll på detta språk."
    },
    previewHeader: "Eksempel på innlegg"
  },
  save: {
    success: "Innstillinger lagret!",
    error: "Feil ved lagring. Prøv igjen."
  },
  customerBanner: "Du redigerer AI-innstillinger for {customerName}",
  about: {
    title: "Om deg selv",
    label: "Fortell AI-en om din bakgrunn og ekspertise",
    placeholder: "Eksempel: Jeg er en digital markedsføringskonsulent med 8 års erfaring innen e-handel. Jeg spesialiserer meg i SEO, Google Ads og konverteringsoptimalisering. Jeg hjelper små og mellomstore bedrifter med å øke sitt nettbaserte salg...",
    helpText: "Dette feltet gir AI-en verdifull kontekst om din profesjonelle bakgrunn, bransje og ekspertise. Informasjonen brukes til å skape mer relevante og autentiske innlegg, men nevnes ikke direkte med mindre det er særlig relevant."
  },
  customPrompt: {
    title: "Tilpasset System Prompt",
    description: "Legg til dine egne instruksjoner til AI-en. Dette er kun for avanserte brukere som ønsker å justere systemprompten.",
    label: "Ekstra instruksjoner til AI-en (valgfritt)",
    placeholder: "Eksempel: 'Skriv alltid i en svært personlig og humoristisk tone' eller 'Fokuser på å stille spørsmål til leserne på slutten av hvert innlegg'",
    warning: "Advarsel: Dette feltet er for avanserte brukere. Feil instruksjoner kan påvirke kvaliteten på innleggene dine negativt. La feltet stå tomt hvis du er usikker."
  }
};

export default aiPromptSettingsNorwegian; 